import { ComponentProps } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Menu } from '~/modules/elements/akui/menu';
import { InputLagSetting, useSettingValue } from '~/routes/settings/settings-state';

interface Props extends ComponentProps<typeof Menu.ButtonGroup> {
  focused: boolean;
}

const InputLag = ({ onClick, focused, ...restProps }: Props) => {
  const [inputLag, setInputLag] = useSettingValue(InputLagSetting);

  useHotkeys('left', () => setInputLag(inputLag - 50), { enabled: focused }, [inputLag]);
  useHotkeys('right', () => setInputLag(inputLag + 50), { enabled: focused }, [inputLag]);

  return (
    <Menu.ButtonGroup {...restProps}>
      <Menu.Button onClick={() => setInputLag(inputLag - 50)} className="aspect-square" size="small" focused={focused}>
        ←
      </Menu.Button>
      <Menu.Button readOnly className="flex-1" data-test="input-lag-value" data-value={inputLag} size="small">
        {inputLag} ms
      </Menu.Button>
      <Menu.Button onClick={() => setInputLag(inputLag + 50)} className="aspect-square" size="small" focused={focused}>
        →
      </Menu.Button>
    </Menu.ButtonGroup>
  );
};

export default InputLag;
